import { CandleValidationsForm } from './types';

export const form_default: CandleValidationsForm = {
  since_milliseconds: 0,
  since_date: '',
  accuracy_threshold: 0.95,
  accuracy_threshold_formatted: '95%',
};
